export interface ITicketTimeline {
    ticketId: number;
    ticketTimelineId: number;
    assignedTo: number;
    createdBy: number;
    assignedDate: Date;
    createdDate: Date;
    endDate?: Date;
    createdByName:string;
    description:string;
    status:string;
    priority:string;
    assignedToName:string;
    active:boolean;
    comments:string;
}